<table class="mat-datetimepickerT2-calendar-table">
  <thead class="mat-datetimepickerT2-calendar-table-header"></thead>
  <tbody (@slideCalendar.done)="_calendarStateDone()"
         (selectedValueChange)="_monthSelected($event)"
         [@slideCalendar]="_calendarState"
         [activeCell]="_adapter.getMonth(activeDate)"
         [labelMinRequiredCells]="2"
         [label]="_yearLabel"
         [rows]="_months"
         [selectedValue]="_selectedMonth"
         [todayValue]="_todayMonth"
         allowDisabledSelection="true"
         mat-datetimepickerT2-calendar-body
         role="grid"></tbody>
</table>
